import { Input as InputJoy, inputClasses } from '@mui/joy';
import { styled } from '@mui/joy/styles';
import { SxProps } from '@mui/joy/styles/types';
import { ChangeEvent, ReactNode } from 'react';
import styleToCss from 'style-object-to-css-string';

export interface InputProps {
  type?: 'text' | 'number' | 'date' | 'password' | 'email' | 'tel' | '';
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  name?: string;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  startDecorator?: ReactNode;
  endDecorator?: ReactNode;
  required?: boolean;
  sx?: SxProps;
  min?: number;
  max?: number;
}

const Input = ({ type = 'text', error, ...rest }: InputProps): JSX.Element => (
  <StyledInput
    type={type}
    error={error}
    {...rest}
    slotProps={{
      input: {
        min: rest.min,
        max: rest.max,
      },
    }}
  />
);

export default Input;

const StyledInput = styled(InputJoy)`
  ${({ theme }) => styleToCss(theme.typography['body-md'])}
  border: 1px solid ${({ theme, error }) => (error ? theme.vars.palette.hoverBrown : theme.vars.palette.grey2)};
  border-radius: 2px;
  background-color: ${({ theme }) => theme.vars.palette.beige};
  &.${inputClasses.disabled} {
    background-color: ${({ theme }) => theme.vars.palette.grey2};
    --Input-placeholderColor: ${({ theme }) => theme.vars.palette.text.secondary};
  }
  padding: 10px 12px 10px 12px;
  color: ${({ theme }) => theme.vars.palette.text.secondary};

  --Input-placeholderColor: ${({ theme }) => theme.vars.palette.grey3};
  --Input-placeholderOpacity: 1;

  box-shadow: none;
`;
